"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Business = function Business() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, _react.default.createElement("g", {
    fill: "#63DC3E"
  }, _react.default.createElement("path", {
    d: "M500 80H308v144h192l-48-72z"
  }), _react.default.createElement("circle", {
    cx: "108",
    cy: "88",
    r: "48"
  })), _react.default.createElement("g", {
    fill: "#242523"
  }, _react.default.createElement("path", {
    d: "M108 112c-30.88 0-56-25.12-56-56S77.12 0 108 0s56 25.12 56 56-25.12 56-56 56zm0-96c-22.06 0-40 17.94-40 40s17.94 40 40 40 40-17.94 40-40-17.94-40-40-40z"
  }), _react.default.createElement("path", {
    d: "M204 304a8 8 0 01-8-8V160c0-22.06-17.95-40-40-40H60c-22.06 0-40 17.94-40 40v136a8 8 0 11-16 0V160c0-30.88 25.12-56 56-56h96c30.88 0 56 25.12 56 56v136a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M172 464H44a8 8 0 01-8-8V192a8 8 0 0116 0v256h112V192a8 8 0 0116 0v264a8 8 0 01-8 8z"
  }), _react.default.createElement("path", {
    d: "M108 464a8 8 0 01-8-8V296a8 8 0 1116 0v160a8 8 0 01-8 8zm0-232a8.26 8.26 0 01-5.68-2.32A8.41 8.41 0 01100 224c0-2.08.88-4.16 2.32-5.68a8.38 8.38 0 0111.36 0A8.41 8.41 0 01116 224c0 2.08-.88 4.16-2.32 5.68A8.41 8.41 0 01108 232zm0-32a8.41 8.41 0 01-5.68-2.32A8.41 8.41 0 01100 192c0-2.08.88-4.16 2.32-5.68a8.38 8.38 0 0111.36 0A8.41 8.41 0 01116 192c0 2.08-.88 4.16-2.32 5.68A8.41 8.41 0 01108 200zm0-32a8.41 8.41 0 01-5.68-2.32A8.41 8.41 0 01100 160c0-2.08.88-4.16 2.32-5.68a8.38 8.38 0 0111.36 0A8.41 8.41 0 01116 160c0 2.08-.88 4.16-2.32 5.68A8.41 8.41 0 01108 168zm392 24H308a8 8 0 01-8-8V40a8 8 0 018-8h192a8 8 0 016.66 12.43L461.6 112l45.04 67.56A7.99 7.99 0 01500 192zm-184-16h169.05l-39.7-59.56a8 8 0 010-8.87L485.04 48H316v128z"
  }), _react.default.createElement("path", {
    d: "M308 416h-32a8 8 0 01-8-8V24c0-13.23 10.77-24 24-24s24 10.77 24 24v384a8 8 0 01-8 8zm-24-16h16V24c0-4.4-3.6-8-8-8s-8 3.6-8 8v376zm56-264a8 8 0 01-8-8V96a8 8 0 0116 0v32a8 8 0 01-8 8zm0-56a8.41 8.41 0 01-5.68-2.32c-1.44-1.52-2.32-3.6-2.32-5.68s.88-4.16 2.32-5.68c3.04-2.96 8.4-2.96 11.36 0 1.44 1.52 2.32 3.6 2.32 5.68s-.88 4.16-2.32 5.68A8.41 8.41 0 01340 80zM196 512H20a8 8 0 01-8-8v-48a8 8 0 018-8h176a8 8 0 018 8v48a8 8 0 01-8 8zM28 496h160v-32H28v32z"
  }), _react.default.createElement("path", {
    d: "M372 464H196a8 8 0 01-8-8v-48a8 8 0 018-8h176a8 8 0 018 8v48a8 8 0 01-8 8zm-168-16h160v-32H204v32z"
  }), _react.default.createElement("path", {
    d: "M500 416H372a8 8 0 01-8-8v-48a8 8 0 018-8h128a8 8 0 110 16H380v32h120a8 8 0 110 16zm-328 16H44a8 8 0 110-16h128a8 8 0 110 16z"
  })));
};

var _default = Business;
exports.default = _default;